import React from 'react';
import { states } from '../../config/supported_areas';
import SelectInput from './SelectInput';

const FSState = ({ options, ...props }) => {
	return <SelectInput options={states} {...props} />;
};

export default FSState;